declare global {
    interface Window {
        Mhecomm_BrowserStorage: CookieAcceptance;
    }
}

export enum CookieAcceptance {
    FULL,
    DENIED
}

export declare interface PolicyConfig {
    cookieAcceptance: CookieAcceptance;
}

class Policy {
    config: PolicyConfig;

    constructor(config: PolicyConfig) {
        this.config = config;
    }

    acceptedCookies() {
        return this.config.cookieAcceptance === CookieAcceptance.FULL;
    }

    deniedCookies() {
        return this.config.cookieAcceptance === CookieAcceptance.DENIED;
    }
}

// Once we have a cookie acceptance feature in place this can look for the correct information on the page.
// For now we are just using cookies.
export default new Policy({
    cookieAcceptance: window.Mhecomm_BrowserStorage || CookieAcceptance.FULL
});
